import {
  MediaFile,
  MediaFileFromJSON,
  MediaFileBundle,
  MediaFileBundleFromJSON,
  MediaRoot,
  MediaRootFromJSON,
  Asset,
  AssetFromJSON,
} from 'elements-sdk'

export function coerceMediaFile (x: any): MediaFile {
  return 'custom_fields' in x ? MediaFileFromJSON(x) : x
}

export function coerceMediaFileBundle (x: any): MediaFileBundle {
  return 'is_shared' in x ? MediaFileBundleFromJSON(x) : x
}

export function coerceMediaRoot (x: any): MediaRoot {
  return 'full_path' in x ? MediaRootFromJSON(x) : x
}

export function coerceAsset (x: any): Asset {
  return 'custom_fields' in x ? AssetFromJSON(x) : x
}
